export const TERMS_OF_USE = 'https://www.heidihealth.com/legal/heidi-scribe-terms-of-use';

// On-prem builds are airgapped: serve the documents from local in-app routes
// instead of the public Heidi website (see src/app-shell/regulatory).
export const LOCAL_TERMS_OF_USE = '/terms-of-use';

export const USAGE_POLICY = 'https://www.heidihealth.com/legal/scribe-usage-policy';

export const LOCAL_USAGE_POLICY = '/usage-policy';

export const PRIVACY_POLICY = 'https://www.heidihealth.com/legal/privacy-policy';

export const LOCAL_PRIVACY_POLICY = '/privacy-policy';

import { getHelpCenterUrl } from '@/helpers/getHelpCenterUrl';
import { getTermsOfUseLink } from '@/helpers/localiseHelper';
import { isOnPrem } from '@/utils/buildProfile';

export type ConsentLegalLinks = {
  usagePolicy: string;
  privacyPolicy: string;
  termsOfUse: string;
};

/**
 * Resolves the Usage Policy / Privacy Policy / Terms of Use links shown on consent
 * surfaces (signup and onboarding).
 *
 * On-prem deployments are airgapped, so the public heidihealth.com pages are
 * unreachable — resolve to the bundled offline routes (see src/app-shell/regulatory).
 *
 * Only the Terms of Use link is localised. `getUsagePolicyLink` exists in
 * localiseHelper with the same locale map, but every consent surface has always
 * pointed at the English Usage Policy, so wiring it up here would silently change
 * which document de/fr/es users are agreeing to. That's a deliberate call for a
 * separate, legal-reviewed change rather than a drive-by in an on-prem link fix.
 */
export const getConsentLegalLinks = (locale = 'en'): ConsentLegalLinks =>
  isOnPrem
    ? {
        usagePolicy: LOCAL_USAGE_POLICY,
        privacyPolicy: LOCAL_PRIVACY_POLICY,
        termsOfUse: LOCAL_TERMS_OF_USE,
      }
    : {
        usagePolicy: USAGE_POLICY,
        privacyPolicy: PRIVACY_POLICY,
        termsOfUse: getTermsOfUseLink(locale),
      };

export const UPDATE_PERSONAL_INFO_HELP_PATH =
  'articles/8906346-how-can-i-update-my-personal-information-on-my-account';

export const getUpdatePersonalInfoHelpUrl = (locale?: string): string =>
  getHelpCenterUrl(UPDATE_PERSONAL_INFO_HELP_PATH, locale);

export const EVIDENCE_IFU_AU =
  'https://cdn.sanity.io/files/fq1n4a7f/production/8d8c9b2837affd2f12aeddc37f656c53344a3cb5.pdf';

// Compliance links
export const COMPLIANCE_LINKS = {
  HIPAA: 'https://www.heidihealth.com/compliance/hipaa',
  GDPR: 'https://www.heidihealth.com/compliance/gdpr',
  APP: 'https://www.heidihealth.com/compliance/app',
  CANADA: 'https://www.heidihealth.com/compliance/canada',
};
